import {
  DietSettingsConnectorApollo,
  SaveMacroConnectorApollo,
} from '@front-activerse/common-components';
import DietSettingsQuery from '../DietSettings/graphql/DietSettingsQuery';
import MacroSettingsContainer from './MacroSettingsContainer';
import { useAppContext } from '@front-activerse/common-components';

const MacroSettingsPage: React.FC = () => {
  const { post } = useAppContext();
  return (
    <DietSettingsConnectorApollo query={DietSettingsQuery}>
      {({ ...dietSettingsData }) => (
        <SaveMacroConnectorApollo post={post}>
          {({ saveMacro }: { saveMacro: (input: any) => Promise<any> }) => {
            return <MacroSettingsContainer {...dietSettingsData} saveMacro={saveMacro} />;
          }}
        </SaveMacroConnectorApollo>
      )}
    </DietSettingsConnectorApollo>
  );
};

export default MacroSettingsPage;
